// Şifre güç çubuğunun istemci kopyası — kural sunucudakiyle AYNI olmak zorunda
// (services/api/Btys.Domain/Calc/Sifre.cs). İkisi ayrışırsa ekran "Güçlü" derken
// sunucu 409 döner ve kullanıcı neyin yanlış olduğunu anlamaz.
//
// Referans pwGuc()'un düzeltilen kusurları (bkz. docs/kararlar-ek.md):
//  · 3. kural /[a-zçğıöşü]/i yazıyordu; `i` bayrağı "küçük harf var mı" testini
//    hiç yanlışlanamaz hâle getiriyordu. Kural küçük VE büyük harf istiyor.
//  · Çubuğun başlangıç genişliği CSS'te %35 amber; hiçbir şey yazılmadan
//    "Orta" görünüyordu. Burada boş girdide genişlik 0.
//  · st[0] = "%15" geçersiz CSS'ti (yüzde önde); doğrusu "15%".

export const SIFRE_ASGARI_UZUNLUK = 10
export const SIFRE_ASGARI_GUC = 3

export type SifreOlcumu = {
  /** 0–4 */
  guc: number
  etiket: string
  /** CSS genişliği, ör. "60%" */
  genislik: string
  renk: string
  /** Sunucunun kabul edeceği güçte mi? */
  yeterli: boolean
  eksikler: string[]
}

const RAKAM = /[0-9]/
const KUCUK = /[a-zçğıöşü]/
const BUYUK = /[A-ZÇĞİÖŞÜ]/
const OZEL = /[^A-Za-z0-9çğıöşüÇĞİÖŞÜ]/

const BASAMAK: [string, string, string][] = [
  ['15%', 'var(--red)', 'Zayıf'],
  ['35%', 'var(--amber-dot)', 'Orta'],
  ['60%', 'var(--amber-dot)', 'Orta'],
  ['80%', '#2E7D46', 'İyi'],
  ['100%', '#2E7D46', 'Güçlü'],
]

export function sifreOlc(sifre: string): SifreOlcumu {
  if (!sifre) {
    return {
      guc: 0,
      etiket: '—',
      genislik: '0%',
      renk: 'var(--line)',
      yeterli: false,
      eksikler: [],
    }
  }

  let guc = 0
  const eksikler: string[] = []

  if (sifre.length >= SIFRE_ASGARI_UZUNLUK) guc++
  else eksikler.push(`en az ${SIFRE_ASGARI_UZUNLUK} karakter`)

  if (RAKAM.test(sifre)) guc++
  else eksikler.push('en az bir rakam')

  if (KUCUK.test(sifre) && BUYUK.test(sifre)) guc++
  else eksikler.push('küçük ve büyük harf')

  if (OZEL.test(sifre)) guc++
  else eksikler.push('en az bir özel karakter')

  const [genislik, renk, etiket] = BASAMAK[guc]
  return { guc, etiket, genislik, renk, yeterli: guc >= SIFRE_ASGARI_GUC, eksikler }
}
